module.exports = __webpack_public_path__ + "img/yiyuan-name3.124cb7ba.png";